"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Source = function Source() {
  return _react2.default.createElement(
    "g",
    { id: "source" },
    _react2.default.createElement("path", {
      d: "M192.3,442.6 L308.2,442.6 L308.2,365.3 L192.3,365.3 L192.3,442.6 L192.3,442.6 Z M0,58 L0,135.4 L500,135.4 L500,58 L0,58 L0,58 Z M77.3,288.4 L422.5,288.4 L422.5,212.4 L77.3,212.4 L77.3,288.4 L77.3,288.4 Z",
      id: "Shape"
    })
  );
};

exports.default = Source;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Source.js
// module id = 2990
// module chunks = 4